module.exports = __webpack_public_path__ + "static/media/banner4.80ec6056.jpg";